var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-form",
        {
          ref: "prepay_reservation",
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v
            },
            expression: "form",
          },
        },
        [
          _c("contact-information", {
            staticClass: "mt-5",
            attrs: { "validation-id": _vm.v__validationId },
          }),
          _vm._v(" "),
          _c("renters-simple-list", { staticClass: "mt-5" }),
          _vm._v(" "),
          _c("steps-navigation", {
            attrs: {
              errors: _vm.v__getErrors(),
              "back-button": false,
              "next-button": "Continue",
            },
            on: { "step-next": _vm.stepNext },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.messageDialog.show,
            callback: function ($$v) {
              _vm.$set(_vm.messageDialog, "show", $$v)
            },
            expression: "messageDialog.show",
          },
        },
        [
          _c("message-modal", {
            attrs: {
              message: _vm.messageDialog.message,
              success: _vm.messageDialog.success,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }